import { useTranslation } from 'react-i18next';
import { CompanySize } from '../../participantEnums';

export const useCompanySizes = () => {
  const { t } = useTranslation('common');
  return [
    {
      value: CompanySize.SIZE_0,
      label: t('participants.enums.companySize.SIZE'),
    },
    {
      value: CompanySize.SIZE_1,
      label: t('participants.enums.companySize.SIZE_1'),
    },
    {
      value: CompanySize.SIZE_2,
      label: t('participants.enums.companySize.SIZE_2'),
    },

    {
      value: CompanySize.SIZE_3,
      label: t('participants.enums.companySize.SIZE_3'),
    },
    {
      value: CompanySize.SIZE_4,
      label: t('participants.enums.companySize.SIZE_4'),
    },

    {
      value: CompanySize.SIZE_5,
      label: t('participants.enums.companySize.SIZE_5'),
    },
    {
      value: CompanySize.SIZE_6,
      label: t('participants.enums.companySize.SIZE_6'),
    },

    {
      value: CompanySize.SIZE_7,
      label: t('participants.enums.companySize.SIZE_7'),
    },
    {
      value: CompanySize.SIZE_8,
      label: t('participants.enums.companySize.SIZE_8'),
    },
  ];
};
